import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import NotificationBell from './NotificationBell';
import CostTrackerWidget from './CostTrackerWidget';

const PAGE_INFO = {
  'queue':            { title: 'Request Queue',          subtitle: 'Review and approve campaign requests' },
  'campaigns-data':   { title: 'Campaign Analytics',     subtitle: 'Historical campaign performance' },
  'analytics':        { title: 'Trends',                 subtitle: 'Analyze campaign trends and insights' },
  'automation':       { title: 'Automation Analytics',   subtitle: 'WhatsApp automation performance' },
  'flow-builder':     { title: 'Automation Flow Builder',subtitle: 'Database-driven journey & campaign mapping' },
  'content-library':  { title: 'Content Library',        subtitle: 'Browse and copy WhatsApp campaign content' },
  'creative-library': { title: 'Creative Library',       subtitle: 'Browse and download campaign creatives' },
  'admin-panel':      { title: 'Admin',                  subtitle: 'Stages, types, content library & bulk upload' },
  'users':            { title: 'User Management',        subtitle: 'Manage users and permissions' },
  'backoffice':       { title: 'Control Panel',          subtitle: 'System settings and configuration' },
  'feature-requests': { title: 'Feature Requests',       subtitle: 'Review feature requests from brands' },
  'audit-log':        { title: 'Audit Log',              subtitle: 'All raw-data edits across analytics' },
  'request':          { title: 'Request Campaign',       subtitle: 'Submit a new campaign request' },
  'my-requests':      { title: 'My Requests',            subtitle: 'View your campaign requests' },
  'my-metrics':       { title: 'Analytics',              subtitle: 'Your campaign performance' },
  'request-feature':  { title: 'Request Feature',        subtitle: 'Suggest a new feature' },
};

const Header = ({ currentPage, rightSlot }) => {
  const { user } = useAuth();
  const info = PAGE_INFO[currentPage] || { title: 'Campaign Hub', subtitle: 'Manage your WhatsApp campaigns' };

  return (
    <header
      className="sticky top-0 z-20 w-full bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80 border-b border-slate-200"
      data-testid="app-header"
    >
      <div className="w-full flex items-center justify-between gap-4 px-4 sm:px-6 lg:px-8 py-3">
        {/* Left: Title block */}
        <div className="min-w-0 flex-1">
          <h1
            className="text-base sm:text-[15px] font-semibold text-slate-900 leading-tight truncate"
            data-testid="header-page-title"
          >
            {info.title}
          </h1>
          <p className="hidden sm:block text-xs text-slate-500 leading-tight truncate mt-0.5">
            {info.subtitle}
          </p>
        </div>

        {/* Right: Actions cluster */}
        <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
          {rightSlot && (
            <div className="hidden md:flex items-center mr-1">
              {rightSlot}
            </div>
          )}

          <div className="hidden sm:block">
            <CostTrackerWidget />
          </div>

          <NotificationBell />

          {/* Divider */}
          <div className="hidden sm:block w-px h-7 bg-slate-200 mx-1" aria-hidden="true" />

          {/* Profile */}
          <div className="flex items-center gap-2">
            <div className="text-right hidden md:block leading-tight">
              <p className="text-xs font-medium text-slate-900 truncate max-w-[140px]">{user?.name}</p>
              <p className="text-[10px] text-slate-500 capitalize">{user?.role}</p>
            </div>
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-medium text-xs flex-shrink-0"
              style={{ backgroundColor: user?.color || '#2EB4AC' }}
              data-testid="header-user-avatar"
            >
              {user?.name?.charAt(0) || 'U'}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile-only second row for slot/cost tracker */}
      {(rightSlot || true) && (
        <div className="sm:hidden flex items-center justify-between gap-2 px-4 pb-2 border-t border-slate-100 pt-2">
          {rightSlot ? rightSlot : <div />}
          <CostTrackerWidget />
        </div>
      )}
    </header>
  );
};

export default Header;
